// utils/taxCompute.js
// Pure computation functions for tax calculations

/**
 * Compute VAT payable from quarter summary.
 * @param {Object} vatSummary - VAT quarter summary from API
 * @param {Number} excessOverride - Optional override for excess from previous quarter
 * @returns {{ outputVat, inputVat, tax2306, excess, payable, carryOver }}
 */
export function computeVatPayable(vatSummary, excessOverride) {
  const outputVat = vatSummary?.outputVAT?.totalVAT || 0;
  const inputVat  = vatSummary?.inputVAT?.totalVAT  || 0;
  const tax2306   = vatSummary?.form2306?.totalTaxWithheld || 0;
  const excess    = Number(excessOverride ?? vatSummary?.excessFromPrevQuarter ?? 0);
  const payable   = outputVat - inputVat - tax2306 - excess;
  const carryOver = payable < 0 ? Math.abs(payable) : 0;
  return { outputVat, inputVat, tax2306, excess, payable, carryOver };
}

/**
 * Extract net tax payable from a Percentage Tax period summary.
 * @param {Object} periodSummary - Percentage Tax quarter summary from API
 * @returns {Number}
 */
export function computePercentagePayable(periodSummary) {
  return Number(periodSummary?.netTaxPayable || 0);
}

/**
 * Format currency in Philippine Peso
 * @param {Number} amount - Amount to format
 * @returns {String} Formatted currency string
 */
export function formatPHP(amount) {
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2
  }).format(Number(amount || 0));
}
